import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import { visuallyHidden } from '@mui/utils';
import { Button, Card, CardContent, CardMedia, Chip, Dialog, DialogContent, DialogTitle, Divider, FormControl, Grid, IconButton, InputLabel, LinearProgress, List, ListItem, ListItemText, MenuItem, Select, Switch } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import FilterDomain from '../domain/FilterDomain';
import { deleteDomain, fetchDomains, fetchLocations, toggleActivation } from '../../store/domainSlice';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import CommentDrawer from '../Common/Drawer';
import { capitalizeWords, ROWS_PER_PAGE } from '../../utils/constant';
import DomainForm from '../domain/DomainForm';
import { formatDate } from '../../utils/helper';
import Confirmation from '../Common/Confirmation';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import ImportDomain from '../domain/ImportDomain';
import { CloseRounded } from '@mui/icons-material';
import { useEffect } from 'react';
import BasicPopover from '../Common/PopOver';
import { NoData } from '../Common/NoData';
import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import { useNavigate } from 'react-router-dom';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { fetchIndustryList } from '../../store/industrySlice';
import PhoneInput from 'react-phone-input-2';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';



function createData(id, keyword, landingPage, isAffiliate, industries, location, updatedAt, active, actions) {
    return {
        id,
        keyword,
        landingPage,
        isAffiliate,
        industries,
        location,
        updatedAt,
        active,
        actions
    };
}

const DomainActions = ({ domain, setSelectedDomain, setDomainModal, canDelete, canEdit, fetchDomainsDetails }) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [openApprove, setOpenApprove] = React.useState(false);
    const [contact, setContact] = React.useState("");
    const dispatch = useDispatch()
    const locationsString = domain?.locations?.map((loc) => loc.display_name).join(', ');
    const handleDelete = async (id) => {
        try {
            dispatch(deleteDomain(id)).then((res) => {
                fetchDomainsDetails()
            })
        } catch (error) {
            console.error(error);
        }
    }

    const stripHtml = (html) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        return div.textContent || div.innerText || "";
    };
    return (
        <>
            <Grid spacing={4} justifyContent={'flex-end'}>
                <Grid size={8}>
                    <CommentDrawer {...{ open, setOpen }} >
                        <Box className="p-3">
                            <Typography variant="h6" gutterBottom>
                                Domain Detail
                            </Typography>
                            <Divider />
                            <div className='role-form-scroller'>
                                <TableContainer component={Paper} className="mb-3 mt-3">
                                    <Table>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell>
                                                    <Typography className='table-detail-cells-head' variant='body2'>Keyword:</Typography>
                                                </TableCell>
                                                <TableCell className=''>
                                                    {domain?.keyword || "N/A"}                                               </TableCell>

                                            </TableRow>
                                            <TableRow>
                                                <TableCell>
                                                    <Typography className='table-detail-cells-head' variant='body2'>Industry:</Typography>
                                                </TableCell>
                                                <TableCell className='td-keyval'>
                                                    {domain?.industries?.length ? domain?.industries[0]?.title : "N/A"}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow sx={{ verticalAlign: 'top' }}>
                                                <TableCell>
                                                    <Typography className='table-detail-cells-head' variant='body2'>Location:</Typography>
                                                </TableCell>
                                                <TableCell className='td-keyval' >
                                                    {domain?.locations?.length ? (
                                                        <List disablePadding dense sx={{ maxHeight: '200px', overflowY: 'auto', }}>
                                                            {domain.locations.map((loc, index) => (
                                                                <ListItem key={index} disableGutters>
                                                                    <ListItemText primary={`${index + 1}. ${loc.display_name}`} />
                                                                </ListItem>
                                                            ))}
                                                        </List>
                                                    ) : (
                                                        "N/A"
                                                    )}
                                                </TableCell>
                                            </TableRow>

                                            <TableRow>
                                                <TableCell>
                                                    <Typography className='table-detail-cells-head' variant='body2'>Title:</Typography>
                                                </TableCell>
                                                <TableCell className='td-keyval'>
                                                    {domain?.title || "N/A"}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>
                                                    <Typography className='table-detail-cells-head' variant='body2'>Body:</Typography>
                                                </TableCell>
                                                <TableCell className='td-keyval'>
                                                    {domain?.body && stripHtml(domain.body).trim() ? (
                                                        <span dangerouslySetInnerHTML={{ __html: domain.body }} />
                                                    ) : (
                                                        "N/A"
                                                    )}
                                                </TableCell>
                                            </TableRow>

                                            <TableRow>
                                                <TableCell>
                                                    <Typography className='table-detail-cells-head' variant='body2'>Landing Page:</Typography>
                                                </TableCell>
                                                <TableCell className='td-keyval'>
                                                    <a href={domain?.route} target="_blank" rel="noopener noreferrer" style={{ color: "inherit", textDecoration: 'underline' }}>
                                                        <Typography color='primary' variant='body2'>   {domain?.route}</Typography>
                                                    </a>
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>
                                                    <Typography className='table-detail-cells-head' variant='body2'>Media:</Typography>
                                                </TableCell>
                                                <TableCell className='td-keyval'>
                                                    {domain?.photos?.length ? <Card sx={{ height: 150, position: 'relative', border: '1px dashed #ccc', backgroundColor: '#fafafa' }}>
                                                        {domain.photos[0]?.image &&
                                                            <CardMedia
                                                                component="img"
                                                                controls
                                                                alt='Card-image'
                                                                src={domain?.photos[0]?.image}
                                                                sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                            />}
                                                        {domain.photos[0]?.video &&
                                                            <CardMedia
                                                                component="video"
                                                                controls
                                                                src={domain?.photos[0]?.video}
                                                                sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                            />}
                                                        {domain.photos[0]?.external_url &&
                                                            <CardMedia
                                                                component={domain.photos[0]?.file_type === "image" ? "img" : domain.photos[0]?.file_type}
                                                                controls
                                                                src={domain?.photos[0]?.image || domain?.photos[0]?.video || domain?.photos[0]?.external_url}
                                                                sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                            />}

                                                    </Card> : "N/A"}
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </Box>
                        <Box className="drawer-footer m-3">
                            <Button
                                type="button"
                                variant="outlined"
                                color="primary"
                                onClick={() => setOpen(false)}
                                className="mt-2 mr-2"
                            >
                                close
                            </Button>
                        </Box>
                    </CommentDrawer>
                    <Box gap={2} display='flex' className="table-margin">
                        <CheckCircleIcon
                            color={'action'}
                            onClick={() => {
                                setOpenApprove(true)
                            }}
                        />
                        <RemoveRedEyeOutlinedIcon className='link-color' onClick={() => {
                            setOpen(true);
                        }} />
                        <EditOutlinedIcon className={`${!canEdit ? 'icon-disabled link-color' : 'link-color'}`} onClick={() => {
                            if (canEdit) {
                                setSelectedDomain(domain)
                                setDomainModal(true)
                            }
                        }} />
                        <DeleteOutlineOutlinedIcon className={`${!canDelete ? 'icon-disabled danger-color' : 'danger-color'}`} onClick={() => {
                            if (canDelete)
                                setIsOpen(true)
                        }} />
                    </Box>
                    <>
                        <Dialog
                            open={openApprove}
                            onClose={() => setOpenApprove(false)}
                            maxWidth="sm"
                            fullWidth
                        >
                            <DialogTitle
                                sx={{
                                    m: 0,
                                    p: 2,
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    borderBottom: "1px solid #e0e0e0",
                                }}>
                                <Typography variant="h6">Domain Approve </Typography>
                                <IconButton
                                    aria-label="close"
                                    onClick={() => setOpenApprove(false)}
                                    sx={{
                                        color: (theme) => theme.palette.grey[500],
                                    }}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </DialogTitle>
                            <DialogContent>
                                <Box className="mt-3">
                                <PhoneInput
                                    country={'us'}
                                    value={contact}
                                    onChange={(value, countryData, e, formattedValue) => {
                                        setContact(formattedValue)
                                    }}
                                    placeholder="Enter Contact number"

                                    inputStyle={{
                                        width: '100%',
                                        marginTop: '16px',
                                        marginBottom: '8px',
                                        // padding: '10px',
                                        height: '55px',
                                        borderRadius: '4px',
                                        backgroundColor: '#FAFBF8',
                                    }}
                                    containerStyle={{
                                        marginBottom: '16px',
                                    }}
                                />

                                <Box className="d-flex justify-content-end mt-3">
                                    <Button
                                        type="button"
                                        variant="outlined"
                                        color="primary"
                                        // onClick={() => setAIContentModal(false)}
                                        className="mt-2 mr-2"
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        className="mt-2"
                                        // disabled={formik.isSubmitting || !(formik.dirty && formik.isValid)}
                                    >
                                        Save
                                    </Button>
                                </Box>
                                </Box>
                            </DialogContent>
                        </Dialog>

                        <Confirmation open={isOpen} setOpen={setIsOpen} msg={"Are you sure you want to delete this Domain"} yesClick={() => { handleDelete(domain.uuid); setIsOpen(false) }} />
                    </>
                </Grid>
            </Grid >
        </>
    )
}

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

const headCells = [
    {
        label: 'Keyword',
        numeric: false,
        disablePadding: false,
        id: 'keyword',
        sortable: true
    },
    {
        label: 'Landing Page',
        numeric: false,
        disablePadding: false,
        id: 'landing_page',
        sortable: false
    },
    {
        label: 'Affiliate',
        numeric: false,
        disablePadding: false,
        id: 'is_affiliate',
        sortable: true
    },

    {
        label: 'Industry',
        numeric: false,
        disablePadding: false,
        id: 'industry__title',
        sortable: false
    },
    {
        label: 'Location',
        numeric: false,
        disablePadding: false,
        id: 'location',
        sortable: false
    },
    {
        label: 'Updated At',
        numeric: false,
        disablePadding: false,
        id: 'updated_at',
        sortable: true
    },
    {
        label: 'Active',
        numeric: false,
        disablePadding: false,
        id: 'active',
        sortable: false
    },
    {
        label: 'Actions',
        numeric: true,
        disablePadding: false,
        id: 'actions',
        sortable: false
    },
];

function EnhancedTableHead(props) {
    const { setOrdering, orderingState, setOrderingState } =
        props;
    const createSortHandler = (property) => (event) => {
        const orderData = orderingState
        const exists = orderData?.find((item) => item.id === property);
        const updated = (() => {

            if (exists) {
                return orderData.map((item) =>
                    item.id === property
                        ? { ...item, order: item.order === "asc" ? "desc" : "asc" }
                        : item
                );
            } else {
                return [...orderData, { id: property, order: "asc" }];
            }
        })();
        setOrderingState(updated)

    };
    React.useEffect(() => {
        const ordering = orderingState.map((item) => {
            return item.order === "asc" ? item.id : "-" + item.id;
        });
        if (ordering?.length) {
            setOrdering(ordering.join(","));
        }

    }, [orderingState]);

    const removeFilter = (property) => {
        const data = orderingState.filter((item) => item.id !== property)
        setOrderingState(data)
    }
    return (
        <TableHead>
            <TableRow>
                {/* {headCells.map((headCell) => (
                    <TableCell
                        className='font-weight'
                        key={headCell.id}
                        align={headCell.numeric ? 'left' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        {headCell.sortable ?
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : 'asc'}
                                onClick={(event) => { onRequestSort(event, headCell.id) }}
                                color='secondary'
                            >
                                {headCell.label}
                                {orderBy === headCell.id ? (
                                    <Box component="span" sx={visuallyHidden}>
                                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                    </Box>
                                ) : null}
                            </TableSortLabel> : headCell.label}
                    </TableCell>
                ))} */}
                {headCells.map((headCell) => {
                    const key = headCell.id;
                    const sortObj = orderingState.find((item) => item.id === key);
                    const isSorted = !!sortObj;
                    const sortDirection = sortObj?.order || "asc";

                    return (<TableCell
                        className="font-weight"
                        key={key}
                        align={headCell.numeric ? "left" : "left"}
                        padding={headCell.disablePadding ? "none" : "normal"}
                        sortDirection={isSorted ? sortDirection : false}
                    >
                        {headCell.sortable ? <TableSortLabel
                            active={isSorted}
                            direction={sortDirection}
                            onClick={createSortHandler(key)}
                            color="secondary"
                            hideSortIcon={false}
                        >
                            {headCell.label}
                            {isSorted && (
                                <Box component="span" sx={visuallyHidden}>
                                    {sortDirection === "desc" ? "sorted descending" : "sorted ascending"}
                                </Box>
                            )}
                            {isSorted && <FilterListOffIcon onClick={(e) => { e.stopPropagation(); removeFilter(headCell.id) }} className="ml-2" size="small" color='primary' />}
                        </TableSortLabel> : headCell.label}
                    </TableCell>)
                })}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};
function EnhancedTableToolbar(props) {
    const { numSelected } = props;
    const industries = useSelector((state) => state.industryReducer.industryList)
    const [open, setOpen] = React.useState(false);

    const [filterOpen, setfilterOpen] = React.useState(false);
    const navigate = useNavigate()
    const { setPage, setQueryString, setisfilter, page, ordering, rowsPerPage, selectedIndustry, fetchDomainsDetails, setSelectedIndustry, domainModal, setDomainModal, selectedDomain, setSelectedDomain, setResetTrigger, resetTrigger } = props;
    return (
        <>
            <DomainForm {...{ domainModal, setDomainModal, setSelectedDomain, selectedDomain, resetTrigger, fetchDomainsDetails }} title={selectedDomain ? "Edit" : "Create"} />
            {/* <Toolbar
                className='main-list-toolbar'
            >
                <Typography
                    className="d-flex flex-grow-1 flex-shrink-1 flex-fill"
                    variant="h6"
                    id="tableTitle"
                    component="div"
                >
                    Domains
                </Typography>
                <FormControl size='small' className='mr-2' sx={{ minWidth: 200 }}
                >
                    <InputLabel id="industry_id">Industry</InputLabel>
                    <Select
                        labelId="industry_id"
                        id="industry_id"
                        name='industry_id'
                        label="Industry"
                        value={selectedIndustry}
                        onChange={(e) => {
                            setSelectedIndustry(e.target.value)
                        }}
                        MenuProps={{
                            PaperProps: {
                                className: "mui-select-menu",
                            }
                        }}
                        sx={{
                            width: 200
                        }}
                        endAdornment={
                            selectedIndustry ? (
                                <IconButton
                                    size="small"
                                    className='mr-4'
                                    onClick={() => setSelectedIndustry(0)}
                                    onMouseDown={(event) => event.stopPropagation()}
                                >
                                    <CloseRounded />
                                </IconButton>
                            ) : null
                        }

                    >
                        <MenuItem value={0}>All</MenuItem>
                        {industries?.length && industries?.map((ele) => <MenuItem value={ele.id}>{ele.title}</MenuItem>)}
                    </Select>

                </FormControl>
                <Tooltip title="Create">
                    <Button variant="contained" className='mr-2' onClick={() => {
                        setOpen(true);

                    }}>Import Domains</Button>
                </Tooltip>
                <Tooltip title="Create">
                    <Button variant="contained" onClick={() => {
                        setResetTrigger(!resetTrigger)
                        setSelectedDomain(null);
                        setDomainModal(true);

                    }}>Create Domain</Button>
                </Tooltip>
                <CommentDrawer {...{ open, setOpen }} className="p-3" >
                    <ImportDomain {...{ open, setOpen }} />
                </CommentDrawer>
            </Toolbar> */}

            <Toolbar className='main-list-toolbar'>
                <Grid container alignItems="center" spacing={1} >
                    <Grid item lg={7} md={12} sm={12} xs={12}>
                        <Typography
                            variant="h6"
                            id="tableTitle"
                            component="div"
                            className="d-flex flex-grow-1"
                        >
                            Domains
                        </Typography>
                    </Grid>

                    <Grid item lg={1.5} md={3} sm={6} xs={6}
                    // sx={{ mb: { xs: 1, sm: 1, md: 0 } }}
                    >
                        <Tooltip title="Import Domains">
                            <Button
                                variant="contained"
                                fullWidth
                                className='mr-2'
                                onClick={() => setOpen(true)}
                            >
                                Import Domains
                            </Button>
                        </Tooltip>
                    </Grid>

                    <Grid item lg={1.5} md={3} sm={6} xs={6}
                    // sx={{ mb: { xs: 1, sm: 1, md: 0 } }}
                    >


                        <Tooltip title="Create Domain">
                            <Button
                                variant="contained"
                                fullWidth
                                onClick={() => {
                                    setResetTrigger(!resetTrigger);
                                    setSelectedDomain(null);
                                    setDomainModal(true);
                                }}
                            >
                                Create Domain
                            </Button>
                        </Tooltip>
                    </Grid>
                    <Grid item lg={1} md={1.5} sm={6} xs={6}
                        sx={{ mb: { xs: 1, sm: 1, md: 0 } }}
                    >
                        <Tooltip title="View Upload logs">
                            <Button
                                variant="outlined"
                                fullWidth
                                startIcon={<ListAltIcon />}
                                onClick={() => { navigate("/domain/import-logs") }}
                            >
                                Logs
                            </Button>
                        </Tooltip>
                    </Grid>
                    <Grid item lg={1} md={1.5} sm={6} xs={6}
                        sx={{ mb: { xs: 1, sm: 1, md: 0 } }}
                    >
                        <Tooltip title="Apply filters">
                            <Button
                                variant="contained"
                                fullWidth
                                // startIcon={<LocalActivityIcon />}
                                onClick={() => { setfilterOpen(true) }}
                            >
                                Filter
                            </Button>
                        </Tooltip>
                    </Grid>
                </Grid>


                {/* Drawer for ImportDomain */}
                <CommentDrawer {...{ open, setOpen }} className="p-3">
                    <ImportDomain {...{ open, setOpen }} />
                </CommentDrawer>
                <CommentDrawer open={filterOpen} setOpen={setfilterOpen} className="p-3">
                    <FilterDomain {...{
                        fetchDomainsDetails, setQueryString, setisfilter
                        , filterOpen, setfilterOpen, setPage, page, ordering, rowsPerPage,
                    }} />
                </CommentDrawer>
            </Toolbar >

        </>
    );

}

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

export default function DomainManage() {
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('calories');
    const [selected, setSelected] = React.useState([]);
    const [rows, setRows] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [selectedIndustry, setSelectedIndustry] = React.useState(0);
    const [queryString, setQueryString] = React.useState("");
    const [isfilter, setisfilter] = React.useState(false);


    const [rowsPerPage, setRowsPerPage] = React.useState(ROWS_PER_PAGE);
    const [domainModal, setDomainModal] = React.useState(false);
    const [selectedDomain, setSelectedDomain] = React.useState({});
    const [resetTrigger, setResetTrigger] = React.useState(false);
    const [opneActiveConfirm, setOpneActiveConfirm] = React.useState(false);
    const domains = useSelector((state) => state.domainReducer.domains)
    const count = useSelector((state) => state.domainReducer.count)
    const loading = useSelector((state) => state.domainReducer.loading)
    const userPermission = useSelector((state) => state.userReducer.userPermission)
    const [orderingState, setOrderingState] = React.useState([])
    const [ordering, setOrdering] = React.useState();
    const domianPermissions = userPermission.find((perm) => perm.model_name === "domain")?.permissions || [];
    let canEdit = domianPermissions.includes("change");
    let canDelete = domianPermissions.includes("delete");
    const dispatch = useDispatch()

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = rows.map((n) => n.id);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const label = { inputProps: { 'aria-label': 'Color switch demo' } };
    const LocationsPreview = ({ locations }) => {
        const [showAll, setShowAll] = React.useState(false);

        if (!locations?.length) return null;

        return (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                {(showAll ? locations : locations.slice(0, 1))?.map((loc) => (
                    <Typography key={loc.id} variant="body2" color="textSecondary">
                        {loc?.display_name ? (
                            <Tooltip title={loc.display_name} arrow disableHoverListener={loc.display_name.length <= 10}>
                                <span>
                                    {loc.display_name.slice(0, 15)}
                                    {loc.display_name.length > 15 ? '...' : ''}
                                </span>
                            </Tooltip>
                        ) : (
                            "N/A"
                        )}
                    </Typography>
                ))}

                {locations.length > 1 && !showAll && (
                    <BasicPopover length={locations.length - 1}>
                        <List disablePadding dense className='location-list'>
                            {locations.slice(1).map((loc, index) => (
                                <ListItem key={index} disableGutters>
                                    <ListItemText
                                        primary={
                                            <Typography color='primary' variant='body2'>{index + 1}. {loc?.display_name}</Typography>
                                        }
                                    />
                                </ListItem>
                            ))}
                        </List>
                    </BasicPopover>
                )}
            </Box>
        );
    };
    const IndustriesPreview = ({ industries }) => {
        const [showAll, setShowAll] = React.useState(false);

        if (!industries?.length) return null;

        return (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                {(showAll ? industries : industries.slice(0, 1))?.map((loc) => (
                    <Typography key={loc.id} variant="body2" color="textSecondary">
                        {loc.title}
                    </Typography>
                ))}

                {industries.length > 1 && !showAll && (
                    <BasicPopover length={industries.length - 1}>
                        <List disablePadding dense className='location-list'>
                            {industries.slice(1).map((loc, index) => (
                                <ListItem key={index} disableGutters>
                                    <ListItemText
                                        primary={
                                            <Typography color='primary' variant='body2'>{index + 1}. {loc?.title}</Typography>
                                        }
                                    />
                                </ListItem>
                            ))}
                        </List>
                    </BasicPopover>
                )}
            </Box>
        );
    };

    const fetchDomainsDetails = () => {
        dispatch(fetchDomains(queryString))
    }
    React.useEffect(() => {

        const rowData = domains?.map((ele) => {

            return createData(ele?.id, ele?.keyword, ele?.route, ele?.is_affiliate, ele?.industries?.length ? <IndustriesPreview industries={ele.industries} /> : "N/A", ele?.locations?.length ? <LocationsPreview locations={ele.locations} /> : "N/A", ele.updated_at,
                <Switch disabled={loading} className={`${!canEdit && 'icon-disabled'}`} checked={ele?.deactivated_on ? false : true} {...label} onClick={(e) => {
                    if (canEdit) {
                        setSelectedDomain(ele)
                        if (!ele?.deactivated_on) {
                            setOpneActiveConfirm(true)
                        } else {
                            dispatch(toggleActivation(ele.uuid))
                        }
                    }
                }} />, <DomainActions {...{ fetchDomainsDetails, domainModal, setDomainModal, setSelectedDomain, canDelete, canEdit }} domain={ele} />)
        })
        setRows(rowData)
    }, [domains, loading])

    // const visibleRows = React.useMemo(() => {
    //     if (rows?.length) {
    //         return [...rows]
    //         // .sort(getComparator(order, orderBy))
    //         // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    //     }
    // }, [rows]);

    function Row(props) {
        const { row, labelId } = props;

        return (
            <React.Fragment>
                <TableRow
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    key={row.id}
                    id={labelId}
                    className='cursor-pointer'
                >
                    <TableCell align="left">{row.keyword || "N/A"}</TableCell>
                    <TableCell align="left">
                        {row?.landingPage ? (
                            <Tooltip title={row.landingPage} arrow>
                                <a
                                    href={row.landingPage}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: "inherit", textDecoration: 'underline' }}
                                >
                                    <Typography
                                        color="primary"
                                        variant="body2"
                                        sx={{
                                            maxWidth: '200px',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            display: 'inline-block',
                                        }}
                                    >
                                        {row.landingPage.length > 25
                                            ? `${row.landingPage.slice(0, 23)}…`
                                            : row.landingPage}
                                    </Typography>
                                </a>
                            </Tooltip>
                        ) : (
                            "N/A"
                        )}
                    </TableCell>
                    <TableCell align="left">{row.isAffiliate ? "Yes" : "No"}</TableCell>
                    <TableCell align="left">{row.industries}</TableCell>
                    <TableCell align="left">{row.location}</TableCell>
                    <TableCell align="left">{formatDate(row.updatedAt)}</TableCell>
                    <TableCell align="left">{row.active}</TableCell>
                    <TableCell align="left">{row.actions}</TableCell>
                </TableRow>

            </React.Fragment >
        );
    }
    useEffect(() => {
        if (isfilter) {
            setisfilter(false)
        }
        else if (selectedIndustry) {
            setQueryString(`?page=${page + 1}&page_size=${rowsPerPage}&ordering=${ordering ? ordering : ""}&industry_ids=${selectedIndustry}`)
        } else {
            setQueryString(`?page=${page + 1}&page_size=${rowsPerPage}&ordering=${ordering ? ordering : ""}`)
        }
    }, [ordering, page, rowsPerPage])

    useEffect(() => {
        if (queryString) {
            fetchDomainsDetails(queryString)
        }
    }, [queryString])

    useEffect(() => {
        dispatch(fetchIndustryList());
        dispatch(fetchLocations());
    }, [])



    return (
        <Box className='w-100'>
            <Confirmation open={opneActiveConfirm} setOpen={setOpneActiveConfirm} msg={"Are you sure you want to Inactive this Domain"} yesClick={() => { dispatch(toggleActivation(selectedDomain.uuid)); setOpneActiveConfirm(false) }} />
            <Paper className="w-100 mb-2" >
                <EnhancedTableToolbar numSelected={selected.length} {...{ setQueryString, setisfilter, fetchDomainsDetails, setPage, selectedIndustry, setSelectedIndustry, domainModal, setDomainModal, setSelectedDomain, selectedDomain, setResetTrigger, resetTrigger, page, ordering, rowsPerPage, }} />
                {loading && <LinearProgress />}
                <TableContainer className='position-relative'>
                    <Table
                        className='min-width-750'
                        aria-labelledby="tableTitle"
                        size={'small'}
                    >
                        <EnhancedTableHead
                            numSelected={selected.length}
                            orderingState={orderingState}
                            setOrderingState={setOrderingState}
                            setOrdering={setOrdering}
                            onSelectAllClick={handleSelectAllClick}
                            onRequestSort={handleRequestSort}
                            rowCount={rows?.length}
                        />
                        <TableBody>
                            {rows?.map((row, index) => {
                                const labelId = `enhanced-table-checkbox-${index}`;
                                return (
                                    <>
                                        <Row row={row} label={labelId} />
                                    </>
                                );
                            })}
                        </TableBody>
                    </Table>
                    {!domains?.length && !loading && <NoData></NoData>}
                    {/* {loading && <Loader className='table-loader' />} */}
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={count}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        </Box>
    );
}
